import React from "react";

/**
 * DotLoader - A reusable animated dot loader component with inline styles
 * Used for loading states in buttons and forms
 */
export const DotLoader = () => {
  const loaderStyles = {
    display: "flex",
    gap: "4px",
    alignItems: "center",
  };

  const dotBaseStyles = {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    animation: "pulse 1.4s ease-in-out infinite",
  };

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(0.4);
              opacity: 0.6;
            }
          }
        `}
      </style>
      <div style={loaderStyles}>
        <span
          style={{
            ...dotBaseStyles,
            background: "#EA5B52",
            animationDelay: "0s",
          }}
        ></span>
        <span
          style={{
            ...dotBaseStyles,
            background: "#E94B8A",
            animationDelay: "0.2s",
          }}
        ></span>
        <span
          style={{
            ...dotBaseStyles,
            background: "#00A676",
            animationDelay: "0.4s",
          }}
        ></span>
        <span
          style={{
            ...dotBaseStyles,
            background: "#FDB927",
            animationDelay: "0.6s",
          }}
        ></span>
      </div>
    </>
  );
};

export default DotLoader;
